import * as React from 'react'
import { styled, css } from '$utils/theme'
import { horizontalMarginsCss, verticalMarginsCss, HorizontalMarginProps, VerticalMarginProps } from '$utils/theme/css'
import { Text } from '../Text'
import { rem } from 'polished'

interface Props {
  className?: string
  half?: boolean
  color?: string
  vertical?: boolean
  full?: boolean
}

const ContainerDiv = styled.div`
  display: flex;
  align-items: center;
`

const DivisionRaw: React.SFC<Props & HorizontalMarginProps & VerticalMarginProps> = ({
  vertical,
  half,
  full,
  ...props
}) =>
  !half ? (
    <div className={props.className} />
  ) : (
    <ContainerDiv>
      <div className={props.className} />
      <Text marginLeft="base" marginRight="base" marginBottom="none">
        o
      </Text>
      <div className={props.className} />
    </ContainerDiv>
  )

export const Division = styled(DivisionRaw)`
  ${horizontalMarginsCss};
  ${verticalMarginsCss};
  ${p =>
    p.vertical
      ? `border-left: solid 1px ${p.theme.colors[p.color] || p.theme.colors.lightGrey}`
      : `border-bottom: solid 1px ${p.theme.colors[p.color] || p.theme.colors.lightGrey}`};
  width: ${p => (p.half ? '50%' : '100%')};

  ${p =>
    p.vertical &&
    css`
      width: auto;
      height: ${p.full ? 'auto' : rem(p.theme.sizes.small)}};
      margin-left: ${rem(p.theme.sizes.mini)}
      margin-right: ${rem(p.theme.sizes.mini)}
    `};
  ${p => p.half && `padding-bottom: ${rem(p.theme.sizes.tiny)}`};
  color: ${p => (p.color ? p.theme.colors[p.color] : 'lightGrey')};
`



// WEBPACK FOOTER //
// ./src/views/components/Division/Division.tsx